import React from 'react'
import styled from 'styled-components'
import { spacing } from 'helpers'
import { Typography, Box } from '@material-ui/core'

export const Svg = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 150px;

  svg {
    margin: 0 auto;
  }
`

export const Content = styled.div`
  background: ${({ theme }) => theme.light};
  width: 100%;
  border-radius: 5px;
  padding: ${spacing(2)};

  svg {
    vertical-align: middle;
  }
  & > div {
    vertical-align: top;
  }
  & > div:last-child {
    float: right;
    display: inline-block;
  }
`

export const Option = styled.div`
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.gray_100};

  & > a {
    padding: ${spacing(2)};
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  &:last-child {
    border-bottom: 1px solid ${({ theme }) => theme.gray_100};
  }

  & h3 {
    font-weight: 400;
  }
`

export const Title: React.FC = ({ children }) => <Typography variant='h3'>{children}</Typography>

export const Subtitle: React.FC = ({ children }) => (
  <Box fontWeight={700} fontSize='subtitle1.fontSize' mb={1} component='span' display='block'>
    {children}
  </Box>
)
